/**
 * The two Vite asset roots the game actually ships. Authority tooling reads this registry rather
 * than carrying a second list, while the runtime imports these exact URL maps.
 */
export const ROOT_ASSET_CONSUMER = 'src/render/world-view.ts';
export const PLATE_ASSET_CONSUMER = 'src/render/chart-plates.ts';
export const COSMETIC_ASSET_CONSUMER = 'src/render/world-view.ts';
/**
 * The paper shell's own material: guide portrait, paper stock and sheet stylesheet,
 * consumed by the semantic shell. Listed by path rather than a glob, and
 * the authority tooling reads this list so the manifest must cover each of them exactly once.
 */
export const UI_ASSET_CONSUMER = 'src/app/game-ui.ts';
export const UI_ASSET_PATHS: readonly string[] = ['src/app/guide-portrait.png', 'src/app/paper-stock.png', 'src/app/game.css'];
export const OUTFITTER_ASSET_CONSUMER = 'src/app/outfitter-assets.ts';
export const OUTFITTER_ASSET_PATHS: readonly string[] = [
  'src/app/portraits/fisher-salt.png', 'src/app/portraits/fisher-reef.png',
  'src/app/portraits/fisher-ember.png', 'src/app/portraits/fisher-moss.png',
  'src/app/portraits/outfitter-keeper.png',
  'src/app/outfitter/lantern-amber-preview.png', 'src/app/outfitter/lantern-green-preview.png',
  'src/app/outfitter/pennant-striped-preview.png',
];
/** Existing governed art also displayed on the Chart and Guide paper surfaces. */
export const UI_SHARED_ROOT_ASSET_PATHS: readonly string[] = ['src/render/baked/murrin-roost.png'];
export const UI_SHARES_PLATE_ASSETS = true;

export const rootAssetUrls = import.meta.glob('./baked/*.png', {
  eager: true, query: '?url', import: 'default',
}) as Record<string, string>;

export const plateAssetUrls = import.meta.glob(['./baked/plates/*.png', '!./baked/plates/*-x2.png'], {
  eager: true, query: '?no-inline&url', import: 'default',
}) as Record<string, string>;

export const cosmeticAssetUrls = import.meta.glob('./baked/cosmetics/*.png', {
  eager: true, query: '?url', import: 'default',
}) as Record<string, string>;
